/* -------------------------------------------------------------------------- */
/* HELPERS: Forms                                                             */
/* -------------------------------------------------------------------------- */
/* eslint-disable no-unused-vars */
import { v4 as uuid } from 'uuid';
import { snakeToCamel } from '@nodes/helpers/string';

const numberTypes = ['mobile', 'phone', 'code_melli', 'number'];
const textTypes = ['text', 'email'];

/**
 * Check if the component is Input
 *
 * @param {string} name
 * @returns {boolean}
 */
const isInput = (name) => numberTypes.includes(name) || textTypes.includes(name);

/**
 * Create Form Elements Object
 *
 * @param {object} configs
 * @param {Array} exclude
 * @returns {*}
 */
export const formElements = (configs, exclude = ['username', 'avatar']) => {
    const array = [];

    Object.keys(configs).forEach((key) => {
        const item = configs[key];
        if (!exclude.includes(item.slug)) {
            // Define type
            let type;
            if (textTypes.includes(item.type)) {
                type = 'text';
            } else if (item.type === 'password') {
                type = 'password';
            } else if (numberTypes.includes(item.type)) {
                type = 'number';
            } else {
                type = item.type;
            }

            // Define Format
            let format;
            if (item.type === 'mobile') {
                format = '(DDDD) DDD DDDD';
            } else if (item.slug === 'code_melli') {
                format = 'DDD-DDDDDD-D';
            } else if (item.type === 'phone') {
                format = '(DDD) DDDD DDDD';
            } else if (item.slug === 'postal_code') {
                format = 'DDDDD-DDDDD';
            }

            const validation = item.type === 'email' ? '|email' : '';
            array.push({
                component_name : isInput(item.type) ? 'input' : item.type,
                id             : `${snakeToCamel(item.slug)}-${uuid() * key}`,
                order          : item.order,
                label          : item.title,
                placeholder    : item.title,
                validation     : item.required ? `required${validation}` : validation,
                name           : item.slug,
                component_class: 'mb-10',
                options        : item.options ? item.options : null,
                color          : 'primary', // TODO: Make it dynamic - backend needed
                type,
                format,
            });
        }
    });
    return array;
};
